(function () {
    'use strict';

    /**
     * Debouncing function determines whether to debounce or accept event.
     *
     * @param func
     * @param threshold
     * @returns {Function}
     */
    var debounce = function (func, threshold) {
        var timeout;

        return function debounced() {
            var obj = this, args = arguments;

            function delayed() {
                func.apply(obj, args);
                timeout = null;
            }

            if (timeout) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(delayed, threshold);
        };
    };

    /**
     * Event debounce is for delaying inputs so that browser is overwhelmed.
     *
     * @param fn
     * @param event
     * @param bindTo - Object to be bound to.
     * @param threshold
     *
     * @returns function
     */
    vhols.eventDebounce = function (fn, event, bindTo, threshold) {
        return fn ? vhols.angEl(bindTo).on(event, debounce(fn, threshold ? threshold : 100)) : vhols.angEl(bindTo).triggerHandler('eventDebounce');
    };

})();